var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Production-Foreman',{attrs:{"foreman-type":"concrete","supplier":_vm.supplier}})
}
var staticRenderFns = []

export { render, staticRenderFns }